var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Tea } from '../../../sendLogV3/export';
import { logger } from '../../../logger';
import { getCookie, setCookie } from "../../../cookieSDK/utils";
import { getIpInfo } from "../../utils";
import { CLASS_NAMES, COOKIE_OPT_OUT_KEY, defaultOptions } from "./const";
import { renderPrivacyButton, renderPrivacyChoicesPage } from "./dom";
var OptOut = /** @class */ (function () {
    function OptOut(options, thirdScripts) {
        if (thirdScripts === void 0) { thirdScripts = []; }
        this._scripts = [];
        if (typeof options !== 'object') {
            throw { code: -1 };
        }
        this.options = Object.assign({}, defaultOptions, options);
        if (Array.isArray(thirdScripts)) {
            this._scripts = thirdScripts;
        }
        this._init();
    }
    // 获取当前状态
    OptOut.prototype._getAcceptStatus = function () {
        var _a, _b;
        var status = JSON.parse(getCookie(COOKIE_OPT_OUT_KEY) || '{}');
        var gpcStatus = (navigator === null || navigator === void 0 ? void 0 : navigator.globalPrivacyControl) === '1';
        // gpc禁止
        if (gpcStatus && !((_a = this.options) === null || _a === void 0 ? void 0 : _a.ignoreGpc)) {
            return false;
        }
        // 用户记录禁止
        if ((status === null || status === void 0 ? void 0 : status.code) === 2) {
            return false;
        }
        // 其余都用默认值
        return ((_b = this.options) === null || _b === void 0 ? void 0 : _b.defaultStatus) === 'accept';
    };
    // 触发回调
    OptOut.prototype._emitEvent = function () {
        var _a, _b;
        var isAccept = this._getAcceptStatus();
        if (!isAccept) {
            (_b = (_a = this.options) === null || _a === void 0 ? void 0 : _a.onRejectAll) === null || _b === void 0 ? void 0 : _b.call(_a);
            return;
        }
        this._acceptAll();
    };
    // 开启Cookie脚本
    OptOut.prototype._acceptAll = function () {
        var _a, _b;
        (_b = (_a = this.options) === null || _a === void 0 ? void 0 : _a.onAcceptAll) === null || _b === void 0 ? void 0 : _b.call(_a);
        this._loadThirdScripts();
    };
    // 加载脚本
    OptOut.prototype._loadThirdScripts = function () {
        if (!this._scripts.length) {
            return;
        }
        var head = document.getElementsByTagName('head')[0];
        this._scripts.forEach(function (curScript) {
            // 先插入外链
            if (Array.isArray(curScript.links)) {
                curScript.links.forEach(function (curLink) {
                    var scriptLinkDom = document.createElement('script');
                    scriptLinkDom.src = curLink;
                    scriptLinkDom.async = true;
                    head.appendChild(scriptLinkDom);
                });
            }
            // 再插入脚本
            if (curScript.script) {
                var scriptCodeDom = document.createElement('script');
                scriptCodeDom.innerHTML = curScript.script;
                head.appendChild(scriptCodeDom);
            }
            if (typeof window.CookieScriptStatus !== 'object') {
                window.CookieScriptStatus = {};
            }
            window.CookieScriptStatus[curScript.key] = true;
        });
    };
    // 渲染Opt-Out入口
    OptOut.prototype._renderEntrance = function () {
        var _this = this;
        var _a, _b;
        var el = this.options.el;
        var containerDom;
        if (typeof el === 'string') {
            containerDom = document.querySelector(el);
        }
        containerDom.innerHTML = renderPrivacyButton((_b = (_a = this.options) === null || _a === void 0 ? void 0 : _a.privacyText) === null || _b === void 0 ? void 0 : _b.privacyBtn);
        var buttonDom = document.querySelector("#cookie-opt-out-button");
        if (!buttonDom) {
            return;
        }
        this._renderPrivacyChoices();
        // 事件监听
        buttonDom.addEventListener('click', function () {
            // 埋点上报
            try {
                Tea.sendLogV3('acv_button_touch', { component_text: 'privacy_choice' });
            }
            catch (e) {
                logger.error('cookie-banner', 'send [privacy_choice] touch log error', e);
            }
            ;
            var containerDom = document.querySelector("#".concat(CLASS_NAMES.container));
            if (!containerDom) {
                return;
            }
            try {
                Tea.sendLogV3('acv_popup', { popup_text: 'privacy' });
            }
            catch (e) {
                logger.error('cookie-banner', 'send [privacy] popup log error', e);
            }
            ;
            containerDom.classList.add(CLASS_NAMES.activeContainer);
            var isAccept = _this._getAcceptStatus();
            // 接受Cookie是置灰，不接受是高亮
            var switchBtn = document.querySelector('#cookie-opt-out-switch');
            if (!isAccept) {
                switchBtn.classList.add(CLASS_NAMES.activeSwitch);
            }
            else {
                switchBtn.classList.remove(CLASS_NAMES.activeSwitch);
            }
        });
        var textDom = buttonDom.querySelector('.cookie-opt-out-text');
        if (!textDom) {
            return;
        }
        buttonDom.addEventListener('mouseover', function () {
            textDom.style.textDecoration = 'underline';
        });
        buttonDom.addEventListener('mouseout', function () {
            textDom.style.textDecoration = 'unset';
        });
    };
    // 渲染具体的页面
    OptOut.prototype._renderPrivacyChoices = function () {
        var _this = this;
        var _a;
        var containerDom = document.createElement('div');
        containerDom.id = CLASS_NAMES.container;
        containerDom.classList.add(CLASS_NAMES.container);
        containerDom.innerHTML = renderPrivacyChoicesPage((_a = this.options) === null || _a === void 0 ? void 0 : _a.privacyText);
        containerDom.querySelector('.cookie-opt-out-close').addEventListener('click', function () {
            containerDom.classList.remove(CLASS_NAMES.activeContainer);
        });
        document.body.appendChild(containerDom);
        // 绑定事件
        var switchBtn = document.querySelector('#cookie-opt-out-switch');
        switchBtn.addEventListener('click', function () {
            var isOptOut = 1; // 1-开 0-关
            if (!switchBtn.className.includes(CLASS_NAMES.activeSwitch)) {
                switchBtn.classList.add(CLASS_NAMES.activeSwitch);
                isOptOut = 1;
            }
            else {
                switchBtn.classList.remove(CLASS_NAMES.activeSwitch);
                isOptOut = 0;
            }
            // 埋点上报
            try {
                Tea.sendLogV3('acv_privacy_status', { botton_status: isOptOut, page_text: 'privacy' });
            }
            catch (e) {
                logger.error('cookie-banner', 'send [privacy status] touch log error', e);
            }
            ;
        });
        var saveBtn = document.querySelector('#cookie-opt-out-save');
        saveBtn.addEventListener('click', function () {
            var isAccept = !switchBtn.className.includes(CLASS_NAMES.activeSwitch);
            setCookie(COOKIE_OPT_OUT_KEY, "{\"status\": \"".concat(isAccept ? 'accepted' : 'rejected', "\", \"code\": ").concat(isAccept ? 1 : 2, ", \"time\": ").concat(new Date().getTime(), "}"));
            containerDom.classList.remove(CLASS_NAMES.activeContainer);
            _this._emitEvent();
        });
    };
    // 初始化IP
    OptOut.prototype._init = function () {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function () {
            var data;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (!!this.options.ignoreIp) return [3 /*break*/, 2];
                        return [4 /*yield*/, getIpInfo(this.options.appId)];
                    case 1:
                        data = _c.sent();
                        if (Number(data.need_compliance) === 1) {
                            this._renderEntrance();
                        }
                        _c.label = 2;
                    case 2:
                        // 触发事件判断，reject or accept
                        this._emitEvent();
                        (_b = (_a = this.options) === null || _a === void 0 ? void 0 : _a.onInit) === null || _b === void 0 ? void 0 : _b.call(_a);
                        return [2 /*return*/];
                }
            });
        });
    };
    return OptOut;
}());
export { OptOut };
//# sourceMappingURL=index.js.map